export const PRODUCT_TRASH_EVENT_TYPE = {
    EAN_ALREADY_EXISTS: 'EAN_ALREADY_EXISTS',
    SKU_CHANGE_REJECTED: 'SKU_CHANGE_REJECTED',
    EAN_CONFLICT_DCIX_SYNC: 'EAN_CONFLICT_DCIX_SYNC',
    EAN_WRITE_BLOCKED_BY_DCIX_LOCK: 'EAN_WRITE_BLOCKED_BY_DCIX_LOCK',
    DUPLICATE_SKU_REJECTED: 'DUPLICATE_SKU_REJECTED',
    PER_ESHOP_PROPAGATION_SKIPPED: 'PER_ESHOP_PROPAGATION_SKIPPED'
} as const;

export type ProductTrashEventType = (typeof PRODUCT_TRASH_EVENT_TYPE)[keyof typeof PRODUCT_TRASH_EVENT_TYPE];

export const PRODUCT_TRASH_SOURCE = {
    PIPES: 'PIPES',
    GWMS: 'GWMS',
    UI: 'UI',
    DCIX_SYNC: 'DCIX_SYNC'
} as const;

export type ProductTrashSource = (typeof PRODUCT_TRASH_SOURCE)[keyof typeof PRODUCT_TRASH_SOURCE];

/** Jediný NAID pro všechny product_trash události (notifikace). */
export const PRODUCT_TRASH_NAID = 'PRODUCT.TRASH_EVENT_RECORDED' as const;

export const PRODUCT_TRASH_EVENT_LABEL: Record<
    ProductTrashEventType,
    { cz: string; en: string }
> = {
    SKU_CHANGE_REJECTED: {
        cz: 'Změna SKU nepovolena',
        en: 'SKU change not allowed'
    },
    DUPLICATE_SKU_REJECTED: {
        cz: 'Vytvoření duplicitního SKU nepovoleno',
        en: 'Duplicate SKU creation not allowed'
    },
    EAN_ALREADY_EXISTS: {
        cz: 'EAN již použit pro jiný produkt',
        en: 'EAN already used for another product'
    },
    EAN_CONFLICT_DCIX_SYNC: {
        cz: 'Konflikt EANu pro WMS sync',
        en: 'EAN conflict for WMS sync'
    },
    EAN_WRITE_BLOCKED_BY_DCIX_LOCK: {
        cz: 'Zápis EANu zablokován zámkem WMS',
        en: 'EAN write blocked by WMS lock'
    },
    PER_ESHOP_PROPAGATION_SKIPPED: {
        cz: 'Per-eshop pole nepropagována (identifikátor vypnutý)',
        en: 'Per-eshop fields not propagated (identifier disabled)'
    }
};

export interface ProductTrashInterface {
    ID: number;
    ESHOP_KEY: string;
    EVENT_TYPE: ProductTrashEventType;
    SOURCE: ProductTrashSource;
    PRODUCT_ID: number | null;
    SKU: string | null;
    EAN: string | null;
    MESSAGE: string;
    CREATED_AT: Date;
    SEEN_AT: Date | null;
    RESOLVED_AT: Date | null;
}
